<mat-card>
  <form [formGroup]="editForm" class="uf-no-form">
    <mat-toolbar color="primary">
      <h1 class="mat-title">Relatie artikel</h1>
      <div>
        <label>actief</label>
        <mat-slide-toggle formControlName="active" matTooltip="Artikel actief"></mat-slide-toggle>
      </div>
    </mat-toolbar>
    <mat-card-content class="uf-form">
      <mat-form-field>
        <mat-label>Artikel</mat-label>
        <mat-select formControlName="articleNumber">
          @for (article of articles; track article.uuid) {
            <mat-option [value]="article.number">
              {{article.name}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Groep</mat-label>
        <mat-select formControlName="groupId">
          @for (group of groups; track group.id) {
            <mat-option [value]="group.id">
              {{group.name}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Naam</mat-label>
        <input matInput type="text" formControlName="name"/>
      </mat-form-field>
      <mat-card-actions>
        <button mat-button mat-raised-button (click)="onCancel()">Annuleren</button>
        <button mat-button mat-raised-button class="mat-primary" (click)="onSave()">Opslaan</button>
      </mat-card-actions>
    </mat-card-content>
  </form>
</mat-card>

